import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { ROOT } from 'configs/routeNames';
import { useAuth } from './useAuth';
import { Spin } from 'antd';

interface PublicRouteProps {
  children: ReactElement;
}

const PublicRoute = ({ children }: PublicRouteProps): ReactElement => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={ROOT} replace />;
  }

  return children;
};

export default PublicRoute;
